import { Directive, ElementRef, HostListener, Input } from '@angular/core'

@Directive({
  selector: '[appFocus]',
  standalone: false,
})
export class FocusDirective {
  constructor(private el: ElementRef) {}

  defaultFocusClass = 'app-focus'

  @Input('appFocus') focusClass: string

  @HostListener('focus')
  onFocus(): void {
    this.el.nativeElement.classList.add(this.focusClass || this.defaultFocusClass)
  }

  @HostListener('blur')
  onBlur(): void {
    this.el.nativeElement.classList.remove(this.focusClass || this.defaultFocusClass)
  }
}
